import PropTypes from 'prop-types';
import { Link } from 'react-router';

import marketplace from 'cfg/marketplace.json';
import css from 'styles/components/checkout/caap/typ/voiceOfCustomer.scss';

const { checkout: { vocImage, vocText, vocUrl } } = marketplace;

const VoiceOfCustomer = (undefined, { testId }) => (
  <div className={css.container}>
    <div>
      <img alt="Your Voice Logo" src={vocImage} />
    </div>
    <div>
      <p>{ vocText }</p>
      <p>
        <Link to={vocUrl} className={css.vocLink} data-test-id={testId('takeSurvey')}>
            Take the survey
        </Link>
      </p>
    </div>
  </div>
);

VoiceOfCustomer.contextTypes = {
  testId: PropTypes.func
};

export default VoiceOfCustomer;
